import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getPasuedSurveyAction = createAsyncThunk(
    'get-paused-survey',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/get-paused-survey`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getPasuedSurveySlice = createSlice({
    name: 'get-paused-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getPasuedSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getPasuedSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getPasuedSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getPasuedSurveyReducer = getPasuedSurveySlice.reducer    